/**
 * One ordering for every project dropdown in the app.
 *
 * Project lists arrive in whatever order the API happened to return, which put
 * the same project in a different place on every page. Strictly alphabetical
 * by name: a project never moves as its dates or status change, so somebody who
 * has learned where "Hydroponics rig" sits keeps finding it there.
 *
 * `localeCompare` with numeric collation so "Project 2" sorts before
 * "Project 10", and sensitivity 'base' so case and accents do not split
 * otherwise-identical names apart.
 */
const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

// Non-mutating: callers hold these arrays in state, and sorting in place
// mutates a state array React believes it owns.
export const sortProjectsByName = (projects) => (
  [...(projects || [])].sort((a, b) => collator.compare(
    a?.project_name || '',
    b?.project_name || '',
  ))
);

export default sortProjectsByName;
